import React from "react";
import List from "../../list/list";
import { SLACK_URL } from "../../../config";

const links = [
  {
    url: SLACK_URL,
    title: <i className="fa fa-slack" />,
    external: true,
    linkProps: {
      rel: "noopener noreferrer",
      target: "_blank",
    },
  },
  {
    url: "https://github.com/myNBGcode",
    title: <i className="fa fa-github" />,
    external: true,
    linkProps: {
      rel: "noopener noreferrer",
      target: "_blank",
    },
  },
  {
    url: "https://www.facebook.com/ibanknbg",
    title: <i className="fa fa-facebook-square" />,
    external: true,
    linkProps: {
      rel: "noopener noreferrer",
      target: "_blank",
    },
  },
  {
    url: "https://twitter.com/NationalBankGR",
    title: <i className="fa fa-twitter" />,
    external: true,
    linkProps: {
      rel: "noopener noreferrer",
      target: "_blank",
    },
  },
  {
    url: "https://www.youtube.com/channel/UCsr0XNS21xKHitSwyGhEIWw",
    title: <i className="fa fa-youtube" />,
    external: true,
    linkProps: {
      rel: "noopener noreferrer",
      target: "_blank",
    },
  },
  {
    url: "https://www.linkedin.com/company/national-bank-of-greece/",
    title: <i className="fa fa-linkedin" />,
    external: true,
    linkProps: {
      rel: "noopener noreferrer",
      target: "_blank",
    },
  },
];

const SocialLinks = () => {
  return (
    <div className="box social">
      <List items={links} className="footer-social" />
    </div>
  );
};

export default SocialLinks;
